import { useTranslation } from "react-i18next";
import { Grid } from "semantic-ui-react";

import { formatPrice } from "utils/formatPrice";

export type KeylockerCommService = {
  title: string;
  price: number;
};

type ServicesProps = {
  title: string;
  services?: KeylockerCommService[];
  vat?: number;
};

export const Services = ({ title, services, vat }: ServicesProps) => {
  if (!services?.length) return null;

  const { t } = useTranslation();

  return (
    <div className="keylocker-comm-section-container">
      <div className="keylocker-comm-section-header">{title}</div>

      <Grid>
        <Grid.Column width={16}>
          <div className="services-header">
            <span>{t("v8_title", "Title")}</span>
            <span>{vat ? t("v8_price_inc_vat", "Price (incl. VAT)") : t("v8_price_excl_vat", "Price (excl. VAT)")}</span>
          </div>
          {services.map((s, key) => (
            <div className="service" key={key}>
              <span>{s.title}</span>
              <span>{vat ? formatPrice(Number((s.price * (1 + vat / 100)).toFixed(2))) : formatPrice(s.price)} €</span>
            </div>
          ))}
        </Grid.Column>
      </Grid>
    </div>
  );
};
